<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Nachricht bearbeiten') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.put(route('admin.messages.update', message))">
                <form-fields :form="form" :message="message" :message-type-options="messageTypeOptions" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'message',
            'messageTypeOptions',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    message_type: this.message.message_type,
                    subject: this.message.subject,
                    text: this.message.text,
                    send_message: false,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>